import { useEffect } from 'react'
import history from '../routerHistory'

const useScrollOnRouteChange = () => {
  useEffect(() => {

    const unlisten = history.listen((args) => {
      // do scroll to top on all views instead of adding liquidity
      if (args.hash === '' && !history.location.pathname.includes("/add/")) {
        setTimeout(() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }, 50)
      }
    })

    return () => unlisten()
  }, [])
}

export default useScrollOnRouteChange
